import {useEffect} from "react";
import {IProject} from "../models/interfaces/project.interface.ts";

/**
 * Hook to poll project status every `intervalMs` milliseconds.
 */
export const useProjectPolling = (
  projects: IProject[],
  getProjectStatus: (projectId: string) => Promise<void>,
  intervalMs: number = 60000 // 1 minute default
): void => {

  useEffect(() => {
    const interval = setInterval(() => {
      projects.forEach((project: IProject) => {
        getProjectStatus(project.id).catch(console.error);
      });
    }, intervalMs);

    return () => clearInterval(interval);
  }, [projects, getProjectStatus, intervalMs]);
};